const featureNames = Object.freeze({
  ACQUISITION_BOOSTER: 'acquisition-booster',
  AUTHORIZATION: 'authorization',
  BACKOFFICE_LEADS: 'backoffice-leads',
  BACKOFFICE_POSTS: 'backoffice-posts',
  BILLWERK: 'billwerk',
  CONTACTS: 'contacts',
  COMPANY_USER: 'company-user',
  COMPANY: 'company',
  CONTRACT: 'contract',
  CRM: 'crm',
  CLIENT_ADVISOR: 'client-advisor',
  CONTENT_CREATOR: 'content-creator',
  NOTIFICATIONS: 'notifications',
  HOPPERMATION: 'hoppermation',
  SALES_PERSON: 'sales-person',
  SSO: 'sso',
  STATISTICS: 'bo-statistics',
  STATISTIC_DASHBOARD: 'statistic-dashboard',
  PERFORMANCE_MARKETING: 'performance-marketing',
  PLOT_VALUATION: 'lp-grundstuecksbewertung',
  VALUATION: 'valuation',
  VARIANT: 'variant',
  ZOHO: 'zoho'
})

export default featureNames
